import { useParams } from 'react-router';

export const relativeRoutes = {
  webcastSetup: 'webcast-setup',
  eventDetails: 'event-details',
  eventDescription: 'event-description',
  eventPermissions: 'event-permissions',
  messaging: 'messaging',
  eventRecording: 'event-recording',
  language: 'language',
  embedding: 'embedding',
  eventAccess: 'event-access',
  protocolSettings: 'protocol-settings',
  ecdn: 'ecdn',
  setupSummary: 'setup-summary',
  media: 'media',
  eventSummary: 'event-summary',
  channelSettings: 'channel-settings',
  planDetailsAndUsage: 'plan-details-and-usage',
  compliance: 'compliance',
  users: 'users',
  channels: 'channels',
  branding: 'branding',
  operator: 'operator',
  security: 'security',
  settings: 'settings',
  dataProtection: 'data-protection',
  accessPermission: 'access-permission',
  streaming: 'streaming',
  archived: 'archived',
};

export const normalize = (path: string) => path.replace(/\/+/g, '/');
export const join = (...strings: string[]) => normalize(strings.join('/'));

export const pathsWithoutChannelId = {
  viewer: '/view',
  iFrame: '/iframe',
  featureToggle: '/toggle',
  subtitlesDemo: '/subtitles-demo',
};

export function useAbsoluteRoutes() {
  const { channelId = '' } = useParams();
  const root = `/${channelId}`;
  const webcastSetup = join(root, relativeRoutes.webcastSetup);
  const eventSummary = join(root, relativeRoutes.eventSummary);
  const channelSettings = join(root, relativeRoutes.channelSettings);

  return {
    root,
    eventSummary,
    webcastSetup,
    webcastSetup_eventDetails: join(webcastSetup, relativeRoutes.eventDetails),
    webcastSetup_eventDescription: join(webcastSetup, relativeRoutes.eventDescription),
    webcastSetup_eventPermissions: join(webcastSetup, relativeRoutes.eventPermissions),
    webcastSetup_messaging: join(webcastSetup, relativeRoutes.messaging),
    webcastSetup_eventRecording: join(webcastSetup, relativeRoutes.eventRecording),
    webcastSetup_language: join(webcastSetup, relativeRoutes.language),
    webcastSetup_embedding: join(webcastSetup, relativeRoutes.embedding),
    webcastSetup_eventAccess: join(webcastSetup, relativeRoutes.eventAccess),
    webcastSetup_protocolSettings: join(webcastSetup, relativeRoutes.protocolSettings),
    webcastSetup_ecdn: join(webcastSetup, relativeRoutes.ecdn),
    webcastSetup_setupSummary: join(webcastSetup, relativeRoutes.setupSummary),
    webcastSetup_media: join(webcastSetup, relativeRoutes.media),
    channelSettings,
    channelSettings_compliance: join(channelSettings, relativeRoutes.compliance),
    channelSettings_dataProtection: join(channelSettings, relativeRoutes.dataProtection),
    channelSettings_planDetailsAndUsage: join(channelSettings, relativeRoutes.planDetailsAndUsage),
    channelSettings_security: join(channelSettings, relativeRoutes.security),
    channelSettings_settings: join(channelSettings, relativeRoutes.settings),
    channelSettings_accessPermission: join(channelSettings, relativeRoutes.accessPermission),
    channelSettings_streaming: join(channelSettings, relativeRoutes.streaming),
    archived: join(root, relativeRoutes.archived),
    users: join(root, relativeRoutes.users),
    channels: join(root, relativeRoutes.channels),
    branding: join(root, relativeRoutes.branding),
    operator: join(root, relativeRoutes.operator),
    operator_messaging: join(root, relativeRoutes.operator, relativeRoutes.messaging),
    ...pathsWithoutChannelId,
  };
}
